// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { MarkupFormula } from './MarkupFormula';
export class MarkupValue {
    constructor(crossRates = undefined, formula = undefined, useMarkupInUnrealizedPnl = true) {
        this.CrossRates = crossRates || {};
        this.Formula = !isNaN(formula) && formula !== null ? formula : MarkupFormula.None;
        this.UseMarkupInUnrealizedPnl = useMarkupInUnrealizedPnl;
    }
}
